// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import configReader from '../../config/config';

// It is a run-time constant and sometimes it is useful to grab it outside React context (e.g. LocalStorageProvider)
export const config = configReader.loadConfig();

export const useConfig = () => {
  return config;
};
